import { render, staticRenderFns } from "./ProductMultiSelect.vue?vue&type=template&id=4866a45e&scoped=true&"
import script from "./ProductMultiSelect.vue?vue&type=script&lang=js&"
export * from "./ProductMultiSelect.vue?vue&type=script&lang=js&"
import style0 from "./ProductMultiSelect.vue?vue&type=style&index=0&id=4866a45e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4866a45e",
  null
  
)

export default component.exports